module.exports = "/_next/static/images/emptySearchDesktop-6d0d6576b47a175252314f2c6b78e43d.jpg";